import { render, staticRenderFns } from "./I18nInitializer.vue?vue&type=template&id=7979a962&"
import script from "./I18nInitializer.vue?vue&type=script&lang=ts&"
export * from "./I18nInitializer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports